import { connect } from 'react-redux';
import noop from 'lodash/noop';

import {
    GA_CANCEL_MODAL_BUTTON_DIMENSION,
    GA_SALES_STATUS_ACTION_POSTPONE_STARTED,
    GA_SALES_STATUS_CATEGORY_EVENT_STATUS,
} from '@eb/event-create-analytics';
import { constants, event } from '@eb/event-create-publish-utils';
import { setWindowLocation } from '@eb/http';
import { trackAnalyticsEvent } from '@eb/site-analytics';

import { OrganizerHeader } from '../components';

const {
    DISPLAY_SALES_STATUS_CANCELLED,
    DISPLAY_SALES_STATUS_POSTPONED,
} = constants;

const {
    connectUtils: {
        dispatchPublishEvent,
        dispatchUnpublishEvent,
        dispatchCancelEvent,
        dispatchDeleteEvent,
        dispatchCancelSchedulePublish,
        changeSalesStatus,
        getPostponeStartButtonNameDimension,
    },
    actions: { clearEventStatusError, navigateAfterClick },
    utils: { getEventStatusButtonType },
} = event;

const getEventActionError = (state) => state.eventStatus?.statusError?.error;

export const mapStateToProps = (state, { eventStatusData, eventId }) => ({
    eventActionError: getEventActionError(state),
    eventStatusButtonType: getEventStatusButtonType(eventStatusData),
    isManagePage: true,
    trackGASelectPostponeStatusEvent: (
        buttonDimension = GA_CANCEL_MODAL_BUTTON_DIMENSION,
    ) =>
        trackAnalyticsEvent({
            category: GA_SALES_STATUS_CATEGORY_EVENT_STATUS,
            action: GA_SALES_STATUS_ACTION_POSTPONE_STARTED,
            dimensions: {
                eventId,
                nameOfButton: getPostponeStartButtonNameDimension(
                    buttonDimension,
                ),
            },
        }),
    navigateToUrl: setWindowLocation,
});

const mapDispatchToProps = (dispatch, { eventId }) => ({
    onPublishClick: (publishClick) =>
        dispatch(dispatchPublishEvent({ eventId })),
    onUnpublishClick: () =>
        dispatchUnpublishEvent(dispatch, eventId).then((result) => {
            if (result?.unpublished) {
                setWindowLocation(`/myevent?eid=${eventId}`);
            }
        }),
    onCancelClick: () =>
        dispatchCancelEvent(dispatch, eventId).then(() =>
            dispatch(
                navigateAfterClick(eventId, DISPLAY_SALES_STATUS_CANCELLED),
            ),
        ),
    onPostponeClick: () =>
        dispatch(
            changeSalesStatus(
                eventId,
                {
                    statusCode: DISPLAY_SALES_STATUS_POSTPONED,
                    customMessage: '',
                },
                GA_CANCEL_MODAL_BUTTON_DIMENSION,
            ),
        )
            .then(() =>
                dispatch(
                    navigateAfterClick(eventId, DISPLAY_SALES_STATUS_POSTPONED),
                ),
            )
            .catch(noop),
    onDeleteClick: () => dispatchDeleteEvent(dispatch, eventId),
    onClearError: () => dispatch(clearEventStatusError()),

    onCancelSchedulePublishClick: () =>
        dispatchCancelSchedulePublish(dispatch, eventId),
});

/**
 * Deprecation warning
 * @param {*} eventId
 * @param {*} eventStatusData
 * @deprecated This function should not be used in the future, please use ConnectedOrganizerHeader instead
 */
const getConnectedOrganizerHeader = (eventId, eventStatusData) =>
    connect(
        (state) => mapStateToProps(state, { eventStatusData, eventId }),
        (dispatch) => mapDispatchToProps(dispatch, { eventId }),
    )(OrganizerHeader);

//Adding new connector strategy as part of https://jira.evbhome.com/browse/EB-145195
export const ConnectedOrganizerHeader = connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrganizerHeader);

export default getConnectedOrganizerHeader;
